import { ppmApi } from './clients';
import {
  PromotionResponse,
  IGetProductComboRequest,
  IGetProductComboResponse,
} from '../types';
import { accessTokenInterceptor } from '@teko/auth';

ppmApi.addInterceptor(accessTokenInterceptor);

export interface getPromotionProps {
  type: string;
  sku: string;
  terminalId?: number;
  /**
   * @deprecated
   */
  terminal?: string;
  language?: string;
}
export class PpmService {
  async getRelatedPromotion({
    type,
    sku,
    terminalId,
    terminal,
    language,
  }: getPromotionProps): Promise<PromotionResponse[]> {
    const res = await ppmApi.get('/promotions', {
      params: { type, skus: sku, terminalId, terminal },
      headers: {
        'Accept-Language': language || '*',
      },
    });

    return res?.data?.result?.promotions || [];
  }

  async getPrivatePromotion({
    type,
    sku,
    terminalId,
    terminal,
    language,
  }: getPromotionProps): Promise<PromotionResponse[]> {
    const res = await ppmApi.get('/private-promotions', {
      params: { type, skus: sku, terminalId, terminal },
      headers: {
        'Accept-Language': language || '*',
      },
    });

    return res?.data?.result?.promotions || [];
  }

  async getProductsCombos({
    skus,
    terminalId,
    language,
  }: IGetProductComboRequest): Promise<IGetProductComboResponse> {
    const res = await ppmApi.post(
      '/products/combos',
      { skus, terminalId },
      {
        headers: {
          'Accept-Language': language || '*',
        },
      },
    );
    return res.data;
  }
}

export const ppmService = new PpmService();
